import { Sparkles } from 'lucide-react'

interface Props {
  criteriaCount: number
  onApplySplit?: () => void
  onDismiss: () => void
}

/**
 * Inline Skerpa heuristic: stories with too many acceptance criteria tend to
 * slip — suggest splitting. Visible only when triggered; user can dismiss for
 * the session via the parent's state.
 */
export function DetailInsight({ criteriaCount, onApplySplit, onDismiss }: Props) {
  return (
    <section className="px-5 py-4" style={{ borderTop: '1px solid var(--color-border-subtle)' }}>
      <div
        className="rounded-lg p-3"
        style={{
          border: '1px solid var(--color-border)',
          background: 'var(--color-bg-card)',
        }}
      >
        <div className="flex items-start gap-2.5">
          <span
            className="flex items-center justify-center flex-shrink-0"
            style={{
              width: 26, height: 26,
              borderRadius: 7,
              background: 'var(--color-warm-900)',
            }}
          >
            <Sparkles style={{ width: 14, height: 14, color: 'var(--color-solution)' }} />
          </span>
          <div className="flex-1">
            <div className="text-[12.5px] font-semibold" style={{ color: 'var(--color-fg)' }}>
              Consider splitting this requirement
            </div>
            <p className="text-[12px] mt-0.5" style={{ color: 'var(--color-fg-secondary)', lineHeight: 1.5 }}>
              It has {criteriaCount} acceptance criteria — large stories tend to slip.
              Skerpa can suggest a split based on the criteria.
            </p>
            <div className="flex items-center gap-2 mt-2">
              {onApplySplit && (
                <button
                  className="text-[12px] font-medium cursor-pointer border-0 rounded"
                  style={{ background: 'var(--color-warm-900)', color: 'white', padding: '5px 10px' }}
                  onClick={onApplySplit}
                >
                  Apply split
                </button>
              )}
              <button
                className="text-[12px] cursor-pointer bg-transparent border-0"
                style={{ color: 'var(--color-fg-muted)', padding: '5px 4px' }}
                onClick={onDismiss}
              >
                Dismiss
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
